import React from 'react';
import PropTypes from 'prop-types';

const SvgCircle = ({ active, ...props }) => {
    const fillColor = active ? '#128383' : '#EAEBF0';
    const strokeColor = active ? '#ffffff' : '#343A72';
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 22 22" {...props}>
            <circle cx="11" cy="11" r="10.375" fill={fillColor} stroke={strokeColor} strokeWidth="1.25" />
        </svg>
    );
};
SvgCircle.propTypes = {
    active: PropTypes.bool,
};
SvgCircle.defaultProps = {
    active: false,
};

export default SvgCircle;
